import { apiSlice } from 'store/api/apiSlice';

export type SportsbookGame = {
  id: string;
  sport?: string;
  league?: string;
  homeTeam?: string;
  awayTeam?: string;
  startTime?: string;
  markets?: Array<{
    marketId?: string;
    market: string;
    baseMarket?: string;
    line?: string;
    options: Array<{ label: string; odds: string }>;
  }>;
};

export type RetailSportsbookResponse = {
  games: SportsbookGame[];
  source?: string;
  /** Set when DB is connected but `odds` is empty */
  message?: string;
};

export const sportsbookApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRetailSportsbook: builder.query<RetailSportsbookResponse, void>({
      query: () => ({ url: '/api/retail/sportsbook' }),
    }),
  }),
});

export const { useGetRetailSportsbookQuery } = sportsbookApiSlice;
